import tw from 'twin.macro';

export const CheckboxListWrapper = tw.div`flex gap-3 flex-wrap`;
